<style scoped>
    .game-list-item:not(.active)::before{
        content:"";
        display: block;
        background: rgba(0,0,0,.4);
        width: 100%;
        height: 100%;
        position: absolute;
    }
    .game-list-item:hover::before{
        background: rgba(0,0,0,.2);
    }
    .text-3d>div{
        font-family:cursive;
        background-clip: text;
        -webkit-background-clip: text;
        grid-area: overlap;
        letter-spacing: 1px;
        -webkit-text-stroke: .2rem transparent;
    }
    .text-3d-bg{
        background-image: repeating-linear-gradient( 105deg, #ffb338 0% , #3e2904 5%, rgb(233, 233, 0) 12%);
        color: transparent;
        transform: scaleY(1.05);
        transform-origin: top;
    }
    .text-3d-fg{
        background-image: repeating-linear-gradient( 5deg, #ffb338 0% , #77571d 23%, yellow 31%);
        color: #2b3038;
        transform: scale(1);
    }
    .bg-gradient-both{
        background-image: linear-gradient(180deg, rgba(255, 255, 255, 0),rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
    }
    .line{
        content: "";
        width: 100%;
        height: 1px;
        background: linear-gradient(90deg,rgba(255,255,255,0),rgba(255,255,255,.3),rgba(255,255,255,0));
    }
    .game-item-hover.text-light:hover{
        background: linear-gradient(180deg,rgba(108,171,163,1) 0%,rgba(128,213,209,1) 20%, rgba(72,118,157,1) 100%);
    }
    
    @media (max-width: 575px){
		.more-game{
            transform: translate(-100%,0);
            position: absolute;
        }
        .more-game.offset{
            animation: offset .25s cubic-bezier(.25, 1.15, .35, 1.08) forwards;
            background: rgba(0,0,0,.5);
        }
        .more-game-switch{
            transform: translate(100%,-100%);
        }
        /* .offset-room{
            animation: offset-room .25s cubic-bezier(.25, 1.15, .35, 1.08) forwards;
        } */
    }
    @keyframes offset {
        from {}
        to {
            /* position: relative; */
            transform: translate(0,0);
        }
    }
    /* @keyframes offset-room {
        from {}
        to {
            transform: translate(24%,0);
        }
    } */
</style>
<style>
    .task-3_25rem>.direction{
        width: 3.25rem;
    }
    @media (min-width: 576px){
        .task-sm-5rem>.direction{
            width: 5rem;
        }
    }
</style>
<template>
    <div class="d-flex flex-column h-100">
        <div class="flex-grow-1 h-0">
            <div v-show="isShowMoreGame" class="position-fixed start-0 end-0 top-0 bottom-0 bg-black bg-opacity-50 index-2 d-sm-none"></div>
            <div class="d-flex flex-column h-100">

                <!-- 横向导航 -->
                <navbar class="order-first" :has-chat-msg="hasChatMsg" :is-fullscreen="isFullscreen"></navbar>

                <!-- 主内容 -->
                <div class="d-flex flex-grow-1 position-relative px-sm-0">
    
                    <!-- 游戏列表 -->
                    <div @click.stop class="d-flex flex-column more-game h-100 index-1 bg-gradient-both index-2" :class="[isShowMoreGame?'offset':'']">
                        <div class="flex-grow-1 h-0">
                            <div @click.stop="showMoreGame" class="more-game-switch d-flex position-absolute top-50 text-vertical end-0 bg-danger text-light rounded-end px-1 py-2 border border-2 border-warning border-start-0 text-center lh-sm d-sm-none" role="button">
                                <span>{{$t("home.moreGame")}}</span>
                            </div>
                            <ul class="h-100 list-unstyled d-flex flex-column text-nowrap m-0 fw-bold text-center overflow-y-scroll scroll-none">
                                <li v-for="item in gameList" :key="item" @click="getRoomList(item)" class="game-item-hover" :class="[item==activeGame?'bg-cyan':'opacity-50',unRoomGameList.indexOf(item)==-1?'text-light':'text-secondary']" role="button">
                                    <div class="py-3 px-3">{{$t("common."+GAME_CODE[item])}}</div>
                                    <div class="line"></div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    
                    <!-- 台面列表 -->
                    <div :class="{'offset-room':isShowMoreGame}" class="flex-grow-1 h-100 d-flex flex-column position-relative index-1">
                        
                        <!-- 电话模式下显示的视频 -->
                        <div v-if="gameModel==GAME_MODEL.tel" class="d-flex flex-column flex-sm-row h-sm-50 px-2 mb-2">
                            <media-video id="video1" class="rounded-5 overflow-hidden me-2" :video-index="0" :video-list="videoList" :room-class="['d-none']" :time-class="['d-none']" :img-class="['position-absolute translate-middle top-50 start-50']"></media-video>
                            <media-video id="video2" class="rounded-5 overflow-hidden" :video-index="1" :video-list="videoList" :room-class="['d-none']" :time-class="['d-none']" :img-class="['position-absolute translate-middle top-50 start-50']"></media-video>
                        </div>
                        
                        <!-- 筛选功能 -->
                        <!-- <div class="d-flex justify-content-between small ps-2 pe-2 pe-sm-3 pb-2">
                            <div class="d-flex">
                                <div :class="{'bg-warning':searchInfo.isCountdown==1}" class="d-flex align-items-center bg-secondary rounded-pill px-2 fw-bold" @click="searchInfo.isCountdown==1?searchInfo.isCountdown=-1:searchInfo.isCountdown=1">计时中</div>
                            </div>
                            <div class="d-flex">
                                <div class="dropdown small">
                                    <div data-bs-toggle="dropdown">
                                        <button type="button" :class="[searchInfo.game!=0?'btn-warning':'btn-dark']" class="btn dropdown-toggle border rounded-pill small py-0">
                                            <span class="me-1 fw-bold">{{searchInfo.game==0?'百家/龙虎':searchInfo.game==1?'百家':'龙虎'}}</span>
                                        </button>
                                    </div>
                                    <ul class="dropdown-menu dropdown-menu-dark">
                                        <li><span class="dropdown-item" @click="searchInfo.game=0">百家/龙虎</span></li>
                                        <li><span class="dropdown-item" @click="searchInfo.game=1">百家</span></li>
                                        <li><span class="dropdown-item" @click="searchInfo.game=3">龙虎</span></li>
                                    </ul>
                                </div>
                                <div class="dropdown small ms-1 ms-sm-3">
                                    <div data-bs-toggle="dropdown">
                                        <button type="button" :class="[searchInfo.isAr!=-1?'btn-warning':'btn-dark']" class="btn dropdown-toggle border rounded-pill small py-0">
                                            <span class="me-1 fw-bold">{{searchInfo.isAr==-1?'新版/经典':searchInfo.isAr==1?'新版':'经典'}}</span>
                                        </button>
                                    </div>
                                    <ul class="dropdown-menu dropdown-menu-dark">
                                        <li><span class="dropdown-item" @click="searchInfo.isAr=-1">新版/经典</span></li>
                                        <li><span class="dropdown-item" @click="searchInfo.isAr=1">新版</span></li>
                                        <li><span class="dropdown-item" @click="searchInfo.isAr=0">经典</span></li>
                                    </ul>
                                </div>
                                <div class="dropdown small ms-1 ms-sm-3">
                                    <div data-bs-toggle="dropdown">
                                        <button type="button" :class="[searchInfo.pokerMode!=-1?'btn-warning':'btn-dark']" class="btn dropdown-toggle border rounded-pill small py-0">
                                            <span class="me-1 fw-bold">{{searchInfo.pokerMode==-1?'明牌/常规':searchInfo.pokerMode==0?'常规':'明牌'}}</span>
                                        </button>
                                    </div>
                                    <ul class="dropdown-menu dropdown-menu-dark">
                                        <li><span class="dropdown-item" @click="searchInfo.pokerMode=-1">明牌/常规</span></li>
                                        <li><span class="dropdown-item" @click="searchInfo.pokerMode=0">常规</span></li>
                                        <li><span class="dropdown-item" @click="searchInfo.pokerMode=1">明牌</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div> -->

                        <!-- 台面列表 -->
                        <div class="flex-grow-1 h-0">
                            <room-list :room-list="roomList" :count-list="countList" :pearl-obj="pearlObj" :img-class="['w-6rem pt-8rem w-sm-7rem pt-sm-9rem']" :bet-class="['flex-sm-row text-sm-start']" @on-ready="isRoomlistReady=true" :class="{'col-12 col-sm-6':$root.hasPearl(activeGame)}"></room-list>
                        </div>
                    
                    </div>

                    <task class="d-flex mb-sm-4 bottom end task-3_25rem task-sm-5rem" switch-class="d-none d-sm-flex" :is-show-task="isShowTask"></task>
    
                </div>
            </div>
        </div>
        <foot-nav :is-show-task="isShowTask" @task-switch="isShowTask=!isShowTask"></foot-nav>
    </div>
</template>
<script>
import {COMMAND,GAME_ID,GAME_TYPE, RESULT,LAYER_TYPE,GAME_CODE, IS_DEBUG,USER,MUTATION_TYPE, GAME_MODEL} from "@/assets/js/config.js"
import navbar from "@/components/public/navbar.vue";
import roomList from '@/components/public/roomList.vue';
import footNav from '@/components/public/footNav.vue';
import mediaVideo from "@/components/public/video.vue";
import task from "@/components/public/task.vue";
import { useLayer } from "@/assets/js/useLayer";
export default {
    components: { navbar,roomList,footNav,mediaVideo,task },
    props: {
        hasChatMsg:false,//是否有未读的客服消息
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
    },
    data() {
        return {
            GAME_CODE,
            GAME_MODEL,
            countList:[],//路单统计列表
            pearlObj: {
                id:0,//台面id
                pearl:[]//路单数据
            },//要重绘路单的对象
            isShowMoreGame:false,//是否显示更多游戏
            isRoomlistReady:false,//台面列表组件是否加载完成
            videoList:[],//大厅视频线路地址，当前支持最多两个
            countdownWorkerList:[],//台面计时器webWorker对象列表
            searchInfo:{
                isCountdown:-1,//是否正在计时
                game:0,//游戏
                isAr:-1,//是否虚拟台
                pokerMode:-1,//开牌模式
            },//筛选信息
            // hideRoomidList:[],//要隐藏的台id
            isShowTask:true,//是否显示活动任务图标
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        activeGame(){
            return this.$store.state.activeGame;
        },
        videoLineList(){
            return this.$store.state.videoLineList;
        },
        currVideoLine(){
			return this.$store.state.currVideoLine;
		},
        gameList(){
            return this.$store.state.gameList;
        },
        gameModel(){
            return this.$store.state.gameModel;
        },
        roomList(){
            return this.$store.state.roomList;
        },
        tabGame(){
            return this.$store.state.tabGame;
        },
        unRoomGameList(){
            return this.$store.state.unRoomGameList;
        },
        tableColumnList(){
            return this.$store.state.tableColumnList;
        },
    },
    mounted() {
        this.setWsMessage();//设置响应事件
        this.init();
    },
    unmounted(){
        delete this.$root.wsMsgObj["home"];
    },
    methods: {
        init(){
            //获取视频线路
            // this.$emit('ws-send',COMMAND.all_getline,this.userInfo.id, this.userInfo.guid);
            this.$root.wsSendJson({
                command: COMMAND.all_getline,
                userid: this.userInfo.id,
                guid: this.userInfo.guid
            });
            //获取游戏列表
            // !this.gameList&&this.$emit('ws-send', COMMAND.all_getgamelist, GAME_TYPE.all, this.userInfo.id, this.userInfo.guid);
            !this.gameList&&this.$root.wsSendJson({
                command: COMMAND.all_getgamelist,
                gameType: GAME_TYPE.all,
                userid: this.userInfo.id,
                guid: this.userInfo.guid
            });
            //获取用户信息
            // this.$emit("ws-send",COMMAND.all_getuserinfo,this.userInfo.id, this.userInfo.guid);
            this.$root.wsSendJson({
                command: COMMAND.all_getuserinfo,
                userid: this.userInfo.id,
                guid: this.userInfo.guid
            });
            //获取台面列表（判断是否相等是防止相同游戏列表台返回厅时，重新加载列表但列表key绑定的是id，id不变所以不触发获取路，此举可减少获取和加载次数）
            if((!this.roomList)||(this.tabGame!=0&&this.activeGame!=this.tabGame)){
                // this.$emit("ws-send",COMMAND.all_getroomlist, this.activeGame,this.userInfo.id, this.userInfo.guid);
                this.$root.wsSendJson({
                    command:COMMAND.all_getroomlist,
                    game:this.activeGame,
                    userid:this.userInfo.id,
                    guid:this.userInfo.guid
                });
            }
            //获取用户券
            // this.$emit("ws-send",COMMAND.all_getticket,this.userInfo.id, this.userInfo.guid);
            this.$root.wsSendJson({
                command: COMMAND.all_getticket,
                userid: this.userInfo.id,
                guid: this.userInfo.guid
            });
        },
        /**
         * 设置websocket响应事件
         */
        setWsMessage(){
            this.$root.wsMsgObj["home"]=(data)=>{
                switch (data.command) {
                    case COMMAND.all_getgamelist:
                        IS_DEBUG&&data.game[GAME_TYPE.real].push(27);//测试环境添加竞猜游戏
                        this.$store.commit({
                            type:MUTATION_TYPE.setUnRoomGameList,
                            unRoomGameList:data.game[3]||[]
                        })
                        this.$store.commit({
                            type:MUTATION_TYPE.setGameList,
                            gameList:data.game[GAME_TYPE.real].filter(v=>this.unRoomGameList.indexOf(v)==-1).concat(data.game[GAME_TYPE.esports].filter(v=>this.unRoomGameList.indexOf(v)==-1),this.unRoomGameList).filter(v=>GAME_CODE[v])
                        })
                        break;
                    case COMMAND.all_getroompearl:
                        this.pearlObj={
                            id:data.id,
                            pearl:data.pearl
                        }
                        this.countList[data.id]=data.count;
                        break;
                    case COMMAND.all_changeboot:
                        if(typeof this.roomList.find(v=>v.id==data.id)!="undefined"){//台面存在且可见
                            //清空路单
                            this.pearlObj={
                                id:data.id,
                                pearl:[]
                            }
                            //更新靴局
                            this.$store.commit({
                                type:MUTATION_TYPE.setRoomList,
                                room:{
                                    id:data.id,
                                    boot:data.boot,
                                    innings:data.innings
                                }
                            })
                            //更新统计
                            this.countList[data.id]=[0,0,0];
                        }
                        break;
                    case COMMAND.all_getline:
                        if(this.gameModel==GAME_MODEL.tel){//电话模式
                            let id=this.currVideoLine;//获取当前选中的视频线路
                            if(!id){//当前没有选中的视频线路，则设置默认线路
                                //由于大厅有视频，所以需要设置默认线路
                                this.$root.setCurrVideoLine(this.$root.getDefaultLineId(0));
                            }
                            //获取大厅视频
                            // this.$emit("ws-send",COMMAND.all_getvideo,0,this.currVideoLine,this.userInfo.id,this.userInfo.guid);
                            this.$root.wsSendJson({
                                command:COMMAND.all_getvideo,
                                tableId:0,
                                lineId:this.currVideoLine,
                                userid:this.userInfo.id,
                                guid:this.userInfo.guid
                            });
                        }
                        break;
                    //电话模式处理
                    case COMMAND.all_getvideo:
                        let videoArr=data.video;
                        let list=[];//拼装好的视频地址数组
                        for (let i = 0; i < videoArr.length; i++) {
                            list.push(data.flvline+'/'+videoArr[i]+'.flv');
                        }
                        this.videoList=list;
                        break;
                }
            }
        },
        /**
         * 显示更多游戏
         */
        showMoreGame(){
            this.isShowMoreGame=this.isShowMoreGame?false:true;
            if(this.isShowMoreGame){//显示状态下点击空白处隐藏
                document.onclick=(e)=>{
                    e.stopPropagation();
                    this.isShowMoreGame=false;
                }
            }
        },
        /**
         * 获取游戏对应台面列表
         */
        getRoomList(gameId){
            if(this.isRoomlistReady){//当页面内组件加载完成时才能再次获取，避免频繁获取
                if(this.unRoomGameList.indexOf(gameId)!=-1){
                    useLayer({str:"游戏开发维护中！"});
                    return;
                }
                this.isRoomlistReady=false;
                (!this.$root.changeGame(gameId,"activeGame"))&&(this.isRoomlistReady=true);//切换不成功需要把组件加载状态置回空闲，否则下次无法操作
            }
        },
    },
    watch: {
        /**
         * 监听视频线路id改变
         */
        currVideoLine(newVal){
            if(this.gameModel==GAME_MODEL.tel){//电话模式
                if(newVal!=""){
                    //获取大厅视频
                    // this.$emit("ws-send",COMMAND.all_getvideo,0,this.currVideoLine,this.userInfo.id,this.userInfo.guid);
                    this.$root.wsSendJson({
                        command:COMMAND.all_getvideo,
                        tableId:0,
                        lineId:this.currVideoLine,
                        userid:this.userInfo.id,
                        guid:this.userInfo.guid
                    });
                }else{
                    this.videoList=null;
                }
            }
        },
        /**
         * 监听guid改变（断线重连）
         */
        "userInfo.guid"(newVal,oldVal){
            if(newVal!=oldVal&&newVal!=""){
                this.init();
            }
        },
        // searchInfo:{
        //     handler(newVal,oldVal){
        //         let arr=this.roomList.filter(v=>v.game!=this.searchInfo.game);
        //         if(arr&&arr.length>0){
        //             this.hideRoomidList=arr.map(v=>v.id);
        //         }
        //     },
        //     deep:true
        // }
    },
}
</script>